export default function makeDefaultGetters () {
  const getters = {
    list (state) {
      return state.ids.map(id => state.keyedById[id])
    },
    get: (state) => (id) => {
      return state.keyedById[id]
    }
  }
  return getters
}
